module.exports = __webpack_public_path__ + "img/downchevron.073ae1c4.svg";